module.exports = __webpack_public_path__ + "media/npc_dota_hero_razor.19ea4336.webm";